import { AppBar, Tab, Tabs } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { propertySubPages } from "./PropertyPage";

const PropertyNavbar = ({property, value}) => {
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        const newSubPage = propertySubPages.filter(subPage => subPage.id === newValue)[0];
        navigate(`../${newSubPage.name}`);
    }

    return property && <AppBar sx={{ position: 'relative' }}>
        <Tabs
            color="secondary"
            textColor="inherit"
            indicatorColor="secondary"
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
        >
            {propertySubPages.map(subPage => <Tab key={subPage.id} value={subPage.id} label={subPage.displayName} />)}
        </Tabs>
    </AppBar>
}

export default PropertyNavbar;